// import Dashboard from './Dashboard'
export default {
  // component: Dashboard,
  component: load(() => import(/* webpackChunkName: "Dashboard" */ './Dashboard')),
  priority: 1000,
  permissions: ['DashboardMenu'],// ,'isAdmin'
  name: app.translate('routes.home.Dashboard'),
  icon: 'view-dashboard',
  drawer: true,
};
